import React from 'react';
import {Helmet} from 'react-helmet-async';
import {absolutePageUrl, resolveOgImageUrl} from '../../util/siteUrl';

/** Видимые сниппеты (title, meta, og, twitter): без формулировки «интернет-магазин» — она уходит в JSON-LD на главной. */
export const DEFAULT_TITLE =
    'Купить ароматические свечи ручной работы — Lutica | доставка по России';

export const DEFAULT_DESCRIPTION =
    'Lutica: ароматические свечи ручной работы, натуральные ароматы для дома. Прозрачный состав соевых и аромасвечей, каталог, доставка по России (Яндекс ПВЗ и по договорённости).';

function documentTitle(title) {
    const t = (title || '').trim();
    if (/[—|]\s*Lutica\s*$/i.test(t)) {
        return t;
    }
    return t ? `${t} — Lutica` : DEFAULT_TITLE;
}

/**
 * Мета-теги для SPA: title, description, canonical, Open Graph, Twitter.
 * og:image — REACT_APP_SITE_OG_IMAGE или логотип из public/lutica-logo-green.jpg + REACT_APP_SITE_URL.
 */
export default function Seo({
    title,
    description,
    pathname = '/',
    noIndex = false,
    jsonLd = null,
}) {
    const resolvedTitle = documentTitle(title);
    const descriptionText = description || DEFAULT_DESCRIPTION;
    const canonical = absolutePageUrl(pathname);
    const ogImage = resolveOgImageUrl();

    return (
        <Helmet>
            <html lang="ru"/>
            <title>{resolvedTitle}</title>
            <meta name="description" content={descriptionText}/>
            {canonical ? <link rel="canonical" href={canonical}/> : null}
            {noIndex ? <meta name="robots" content="noindex, nofollow"/> : null}

            <meta property="og:type" content="website"/>
            <meta property="og:title" content={resolvedTitle}/>
            <meta property="og:description" content={descriptionText}/>
            {canonical ? <meta property="og:url" content={canonical}/> : null}
            <meta property="og:locale" content="ru_RU"/>
            {ogImage ? <meta property="og:image" content={ogImage}/> : null}

            <meta name="twitter:card" content={ogImage ? 'summary_large_image' : 'summary'}/>
            <meta name="twitter:title" content={resolvedTitle}/>
            <meta name="twitter:description" content={descriptionText}/>
            {ogImage ? <meta name="twitter:image" content={ogImage}/> : null}

            {jsonLd ? (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            ) : null}
        </Helmet>
    );
}
